module.exports = __webpack_public_path__ + "img/u87.4e4cf860.png";